import React from "react";
import { ManageInvestment } from "../../../containers";

const Investment = (props) => {
  return <ManageInvestment {...props} />;
};

export default Investment;
